import axios from 'axios';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginAuthContext } from '../context/auth';
import Navbar from './Dashboard/Navbar';
import Footer from './Footer';


function LoginForm() {
    const navigate = useNavigate();
    const { setAdminLoginState } = useContext(LoginAuthContext)
    const [email, setEmail] = useState("")
    const handleChange = e => {
        setEmail(e.target.value);
    }
    const [password, setPassword] = useState("")

    const passwordChange = e => {
        setPassword(e.target.value);
    }
    const AuthenticateLogin = () => {
        // event.preventDefault()
        axios.post(`${process.env.REACT_APP_NODE_URL}/admin/login`, {
            email: email,
            password: password
        })
            .then(function (response) {
                if (response.data.status === 200) {
                    if (response.data.userInfo.role === "admin") {
                        setAdminLoginState("admin")
                        navigate("/admin");
                    }
                    else if (response.data.userInfo.role === "manager") {
                        setAdminLoginState("manager")
                        navigate("/manager");
                    }
                    else if (response.data.userInfo.role === "support") {
                        setAdminLoginState("support")
                        navigate("/support");
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }



    return (
        <>
            {/* <form> */}
            <Navbar />
            <div className='container-fluid bg'>
                <div className='row' style={{ minHeight: "100vh" }}>
                    <div className='col-7'></div>
                    <div className='d-flex col-4 justify-content-center align-items-center bg-white' style={{ height: "100vh" }}>
                        <div className='align-middle w-75'>
                            <h2 className='login-heading'>Sign in</h2>
                            <label className='form-label float-start'>Email:</label>
                            <input className='form-control' type="email" name="email" id="email" value={email} onChange={handleChange} />
                            <label className='form-label float-start mt-3'>Password:</label>
                            <input className='form-control' type="password" name="password" id="password" value={password} onChange={passwordChange} />
                            <p className="text-left"><a href='#'>Forgot Password</a></p>
                            <button type="submit" className='btn btn-md btn-primary mt-3' onClick={() => { AuthenticateLogin() }}>Login</button>
                        </div>

                    </div>

                    <div className='col-1'></div>
                </div>
            </div>

            {/* </form> */}
            <Footer />
        </>

    )
}

export default LoginForm;